import _get from 'lodash/get';
import intl from 'react-intl-universal';
import Logger from 'js-logger';
import { localizationConstants, localizationUtils, Localization } from '@lifesize/clients.localization';
import { lsGet, LsKey, lsSet } from 'utils/localStorageUtils';

const DEFAULT_LOCALE = localizationConstants.defaultLanguageId;
const getCurrentLanguage = (): string =>
  localizationUtils.getLanguageId(_get(Office, 'context.displayLanguage', DEFAULT_LOCALE));

/*
 if user has already selected a language,then read it from local storage
 if not, return navigator language.
 if navigator language is not supported then fall back to en-US
*/
const initLanguageId = getCurrentLanguage() || lsGet(LsKey.Locale) || navigator.language || DEFAULT_LOCALE;
const localization = new Localization({ id: initLanguageId }); // Note: these locales are compliant with the ids in localizationConstants.supportedLanguageList
const locales = {
  'cs-CZ': require('@lifesize/strings/outlook/cs.json'),
  'de-DE': require('@lifesize/strings/outlook/de.json'),
  'en-US': require('@lifesize/strings/outlook/en.json'),
  'es-ES': require('@lifesize/strings/outlook/es.json'),
  'fi-FI': require('@lifesize/strings/outlook/fi.json'),
  'fr-FR': require('@lifesize/strings/outlook/fr.json'),
  'it-IT': require('@lifesize/strings/outlook/it.json'),
  'ja-JP': require('@lifesize/strings/outlook/ja.json'),
  'ko-KR': require('@lifesize/strings/outlook/ko.json'),
  'nl-NL': require('@lifesize/strings/outlook/nl.json'),
  'no-NO': require('@lifesize/strings/outlook/no.json'),
  'pl-PL': require('@lifesize/strings/outlook/pl.json'),
  'pt-BR': require('@lifesize/strings/outlook/pt.json'),
  'ru-RU': require('@lifesize/strings/outlook/ru-RU.json'),
  'sv-SE': require('@lifesize/strings/outlook/sv.json'),
  'zh-Hans': require('@lifesize/strings/outlook/zh.json'),
  'zh-Hant': require('@lifesize/strings/outlook/zh-Hant.json')
};

const changeLanguage = (language: any) => {
  lsSet(LsKey.Locale, language.id);
  window.location.reload();
};

const getCookieLink = (): string => {
  return localization.cookieCompliance;
};

const getCurrentLanguageId = (): string => {
  return _get(Office, 'context.displayLanguage') || localization.languageId || DEFAULT_LOCALE;
};

const getHelpLink = (): string => {
  return localization.helpPageGuest;
};

const getLegacyLanguageId = (): string => {
  return localizationUtils.getLegacyLanguageId(getCurrentLanguageId()) || 'en';
};

const getPrivacyLink = (): string => {
  return localization.privacyPolicy;
};

const getTosLink = (): string => {
  return localization.termsOfService;
};

const loadLocales = async (locale: string) => {
  const appLocale = locale || DEFAULT_LOCALE;
  new Promise(async (resolve) => {
    await intl.init({
      currentLocale: appLocale,
      locales,
      fallbackLocale: DEFAULT_LOCALE
    });
    Logger.info('Language initialized to: ' + appLocale);
    Logger.info('Language fallback initialized to: ' + DEFAULT_LOCALE);
    resolve(true);
  });
};

export {
  changeLanguage,
  getCookieLink,
  getCurrentLanguage,
  getCurrentLanguageId,
  getHelpLink,
  getLegacyLanguageId,
  getPrivacyLink,
  getTosLink,
  loadLocales
};
